// Import necessary types
import { TaskColumn } from '@common-models/task-column';
import { isTempId, tasksSelectOneFieldById } from "@common-reducers/DBServiceThunks";
import { usedComponentSelector } from '@common-reducers/TaskSelectors';
import { useAppSelector } from '@common-reducers/hooks/store.hook';
import { memo, useMemo } from 'react';
import CellWrapper from "../columns-cells/cell-wrapper";
import { Skeleton } from '@mui/material';
import { PopperPlacement } from '../columns-cells/cell-interface';

// Define an interface for the props
interface ColumnCellProps {
  column: TaskColumn;
  taskId: string;
  pickerPlacement?: PopperPlacement;
}

export const ColumnCell = memo<ColumnCellProps>(({ column, taskId, pickerPlacement }) => {
  const groupId = useAppSelector((state) => tasksSelectOneFieldById(state.DBTasksReducer, taskId, "groupId") as string | undefined);
  const boardId = useAppSelector((state) => tasksSelectOneFieldById(state.DBTasksReducer, taskId, "boardId") as string | undefined);
  const usedComponent = useAppSelector((state) => usedComponentSelector(state, column.type));

  // For whatsapp-id-cell in board task rows, default to opening upward
  const effectivePlacement = useMemo(() => {
    if (pickerPlacement) return pickerPlacement;
    if (column.type === 'whatsapp-id-cell') return 'top' as PopperPlacement;
    return undefined;
  }, [pickerPlacement, column.type]);

  if (!usedComponent) return null;

  return (
    column.static && isTempId(column._id ?? null) ? <Skeleton /> : <CellWrapper
      columnId={column._id ?? null}
      taskId={taskId}
      groupId={groupId ?? null}
      boardId={boardId ?? null}
      cellComponent={usedComponent}
      pickerPlacement={effectivePlacement}
    />
  );
});
